export class JobProgressStepBucketDataBackupData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backedUpObjects",
            "baseName": "backedUpObjects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backedUpBytes",
            "baseName": "backedUpBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepBucketDataBackupData.attributeTypeMap;
    }
    constructor() {
    }
}
